export class TooManyRequestsError extends Error {}
